var DocumentRequestDashboardModule = (function () {
    function DocumentRequestDashboardModule() {
    }
    return DocumentRequestDashboardModule;
}());
export { DocumentRequestDashboardModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request-dashboard/document-request-dashboard.module.ts.pre-build-optimizer.js